import { useState, useEffect } from 'react';
import SubPageTabs from './SubPageTabs.jsx';
import OnboardingFormHotglue from './onboarding/OnboardingFormHotglue.jsx';
import IntegrationStatus from './overview/IntegrationStatus.jsx';
import IntegrationProductsGrid from './products/IntegrationProductsV2.jsx';
import IntegrationCustomerUpload from './uploads/IntegrationCustomerUpload.jsx';
import posthog from 'posthog-js';
import OnboardingConfiguration from './onboarding/OnboardingConfiguration.jsx';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from '@heroicons/react/20/solid';

export default function IntegrationScaffold({ integration, connection, initialTab }) {

  const {
    connection_id,
    status,
    integrationId,
    data_sources: dataSources,
    permissions
  } = connection;

  let {
    tabs,
    name: integrationName,
    defaultTab,
    onboardingExtras,
    setupTab,
    customSetupTab
  } = integration;

  const allowedTabs = tabs.map((tab) => tab.id);

  const [currentTab, setCurrentTab] = useState((status === 'configuring' || status === 'new' || status === null) ? setupTab : (initialTab && allowedTabs.includes(initialTab) ? initialTab : defaultTab));

  useEffect(() => {
    posthog.capture('$pageview');
  }, []);

  const hasEditPermission = permissions.includes('edit');

  const handleTabClick = (tab) => {
    setCurrentTab(tab);
  };

  const isRestrictedTab = (tab) =>
    (tab === 'credentials' || tab === 'setup') && !hasEditPermission;

  const renderContent = () => {
    if (isRestrictedTab(currentTab)) {
      return (
        <div className='mt-5 pl-5 pr-5 pb-5 bg-white shadow p-6 text-sm text-red-700'>
          You don’t have permission to view this tab.
        </div>
      );
    }
    

    return (
      <div className='mt-5 pl-5 pr-5 pb-5 bg-white shadow'>
        <SubPageTabs
          navigation={tabs.map((item) => ({
            ...item,
            current: item.id === currentTab,
          }))}
          onTabClick={handleTabClick}
        />
        <hr />
        {currentTab === 'products' && (
          <IntegrationProductsGrid integrationId={integrationId} />
        )}
        {currentTab === 'hotglue' && (
          <OnboardingFormHotglue connection_id={connection_id} tap={onboardingExtras?.tap} flow_id={onboardingExtras?.flow_id} defaultValues={{ uri: onboardingExtras?.uri }} />
        )}
        {currentTab === 'status' && <IntegrationStatus 
          status={status}
          connection_id={connection_id}
          name={integrationName}
        />}
        {currentTab === 'upload' && (
          <IntegrationCustomerUpload dataSources={dataSources ?? []} permissions={permissions} />
        )}
        {currentTab === 'onboarding' && (
          <OnboardingConfiguration connection_id={connection_id} permissions={permissions} />
        )}
        {currentTab === 'customSetup' && (
          customSetupTab()
        )}
      </div>
    );
  };

  return (
    <main>
      <div className='mx-auto sm:px-6 lg:px-8 ml-3'>
        <h1 className='text-3xl font-bold leading-tight tracking-tight text-gray-900 mt-2 pt-8 flex items-center'>
          <Link to='/integrations'>
            <ArrowLeftIcon className="h-5 w-5 text-gray-400 mr-2" aria-hidden="true" />
          </Link>
          {integrationName}
        </h1>
        {renderContent()}
      </div>
    </main>
  );
}
